import { type ClientContext, ContextClient } from '~/services/contextClient';
import AcuityClientFactory from './acuityClient.factory';
import type {
    AcuityClientInterface,
    AcuityAppointmentTypesResponse,
    AcuityGroupMapping,
    UpdateAcuityGroupMappingParams,
} from './acuityClient.types';
import type { AxiosPromise } from 'axios';

class AcuityClient extends ContextClient<AcuityClientInterface> {
    constructor() {
        super(AcuityClientFactory);
    }

    getAppointmentTypes(context: ClientContext): AxiosPromise<AcuityAppointmentTypesResponse> {
        const client = this.getClient(context);
        return client.getAppointmentTypes();
    }

    getGroupMapping(context: ClientContext, groupId: string): AxiosPromise<AcuityGroupMapping> {
        const client = this.getClient(context);
        return client.getGroupMapping(groupId);
    }

    updateGroupMapping(
        context: ClientContext,
        groupId: string,
        data: UpdateAcuityGroupMappingParams
    ): AxiosPromise<void> {
        const client = this.getClient(context);
        return client.updateGroupMapping(groupId, data);
    }
}

export default new AcuityClient();
